// Small helpers to add common Content-Type headers to Axios requests.
// Use in calls like: api.post(url, data, asJson()) or asMultipart(config).

export const JSON_HEADERS = { "Content-Type": "application/json" };
export const FORM_HEADERS = {
  "Content-Type": "application/x-www-form-urlencoded",
};
export const MULTIPART_HEADERS = { "Content-Type": "multipart/form-data" };

// Merge given base headers into an Axios config (preserves any existing headers).
export function withHeaders(base) {
  return (config = {}) => ({
    ...config,
    headers: { ...(config.headers || {}), ...base },
  });
}

export const asJson = withHeaders(JSON_HEADERS);
export const asForm = withHeaders(FORM_HEADERS);
export const asMultipart = withHeaders(MULTIPART_HEADERS);

// Examples:
// api.post("/route", body, asJson());
// api.post("/upload", formData, asMultipart({ timeout: 15000 }));
// api.get("/items", asJson({ params: { page: 1 } }));
